module.exports = __webpack_public_path__ + "static/media/cog.180788e7.svg";